(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tk-content"] && !Shopify.designMode) return;
  try {
    function setupTopKippahQuote() {
  const form = document.getElementById("TopKippahQuote");
  if (!form || form.dataset.quoteReady) return;
  form.dataset.quoteReady = "true";
  const requestType = form.querySelector("#tk-request-type");
  const quantity = form.querySelector("#tk-quantity");
  if (!requestType || !quantity) return;
  const sync = () => {
    const sample = requestType.selectedOptions[0].dataset.sample === "true";
    quantity.min = sample ? "1" : "50";
    if (sample) { quantity.max = "1"; quantity.value = "1"; }
    else { quantity.removeAttribute("max"); if (Number(quantity.value) < 50) quantity.value = ""; }
    form.querySelector("[data-bulk-note]").hidden = sample;
    form.querySelector("[data-sample-note]").hidden = !sample;
  };
  requestType.addEventListener("change", sync);
  sync();
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", setupTopKippahQuote);
else setupTopKippahQuote();
document.addEventListener("shopify:section:load", setupTopKippahQuote);
  } catch(e) { console.error(e); }
})();

})();
